module.exports = __webpack_public_path__ + "img/logo拷贝.805df60c.png";